"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var MenuRounded_1 = __importDefault(require("@mui/icons-material/MenuRounded"));
var react_router_dom_1 = require("react-router-dom");
var Dashboard_1 = __importDefault(require("@mui/icons-material/Dashboard"));
var ShoppingCart_1 = __importDefault(require("@mui/icons-material/ShoppingCart"));
var Person_1 = __importDefault(require("@mui/icons-material/Person"));
var ExitToApp_1 = __importDefault(require("@mui/icons-material/ExitToApp"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var icons_material_1 = require("@mui/icons-material");
var PAGES = [
    "Products",
    "Orders",
    "Profile",
    "Chat",
    "Notifications",
    "LOGOUT",
];
var DrawerComp = function () {
    var _a = (0, react_1.useState)(false), openDrawer = _a[0], setOpenDrawer = _a[1];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var handlePageClick = function (page) {
        setOpenDrawer(false);
        if (page === "LOGOUT") {
            js_cookie_1.default.remove("token");
            navigate("/login");
        }
        else if (page === "Profile") {
            navigate("/seller-profile");
        }
        else {
            // Navigate to other pages
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            navigate("/seller-home/".concat(page.toLowerCase()));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Drawer, { open: openDrawer, onClose: function () { return setOpenDrawer(false); }, PaperProps: {
                style: {
                    background: "#1A2138",
                },
            } },
            react_1.default.createElement(material_1.List, null, PAGES.map(function (page, index) { return (react_1.default.createElement(material_1.ListItemButton, { onClick: function () { return handlePageClick(page); }, key: index, sx: { color: "white" } },
                react_1.default.createElement(material_1.ListItemIcon, null,
                    page === "Products" && (react_1.default.createElement(Dashboard_1.default, { sx: { color: "white" } })),
                    page === "Orders" && (react_1.default.createElement(ShoppingCart_1.default, { sx: { color: "white" } })),
                    page === "Notifications" && (react_1.default.createElement(icons_material_1.Notifications, { sx: { color: "white" } })),
                    page === "Chat" && react_1.default.createElement(icons_material_1.Message, { sx: { color: "white" } }),
                    page === "Profile" && react_1.default.createElement(Person_1.default, { sx: { color: "white" } }),
                    page === "LOGOUT" && react_1.default.createElement(ExitToApp_1.default, { sx: { color: "white" } })),
                react_1.default.createElement(material_1.ListItemText, { primary: page }))); }))),
        react_1.default.createElement(material_1.IconButton, { sx: {
                color: "white",
                marginLeft: "auto",
                "&:hover": {
                    color: "#FFB822",
                },
            }, onClick: function () { return setOpenDrawer(!openDrawer); } },
            react_1.default.createElement(MenuRounded_1.default, null))));
};
exports.default = DrawerComp;
